import React, { Component } from 'react';
import { NumberFormatValues, NumericFormat, SourceInfo } from 'react-number-format';

interface FormattedInputProps {
  config: {
    id: string;
    name: string;
    allowNegative?: boolean;
    maxLength?: number;
    required?: boolean;
    thousandSeparator?: string;
    prefix?: string;
    suffix?: string;
    type: 'text' | 'tel' | 'password' | any;
    isAllowed?: any;
    allowLeadingZeros?: boolean;
    decimalScale?: number;
  };
  value: string;
  onValueChange: (values: NumberFormatValues, sourceInfo: SourceInfo) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>; // Updated type
  placeholder: string;
  errors: string;
}
class FormattedInput extends Component<FormattedInputProps> {
  render() {
    const { config, value, onValueChange, onBlur, placeholder, errors } = this.props;

    return (
      <>
        <NumericFormat
          id={config.id}
          name={config.id}
          type={config.type}
          allowNegative={config.allowNegative}
          maxLength={config.maxLength}
          required={config.required}
          thousandSeparator={config.thousandSeparator}
          prefix={config.prefix}
          suffix={config.suffix}
          isAllowed={config.isAllowed}
          allowLeadingZeros={config.allowLeadingZeros}
          value={value}
          onBlur={onBlur}
          onValueChange={onValueChange}
          placeholder={placeholder}
          decimalScale={config.decimalScale}
          className={`form-control ${errors ? 'is-invalid' : ''}`}
        />
        {config.name && (
          <label
            htmlFor={config.id}
            className="form-label">
            {config.name}
          </label>
        )}
      </>
    );
  }
}

export default FormattedInput;
